export enum EntryUrlEnum {
  user = '/cabinet',
  operator = '/operator',
  technical_operator = '/technical-operator',
  technicalsupport = '/technical-operator',
  admin = '/admin'
}

const USER_CABINET_ROLES = ['user', 'guest', ''];

export function normalizeRole(role?: string | null): string {
  return (role || '').toLowerCase().replace(/[\s-]+/g, '_');
}

export function isUserCabinetRole(role?: string | null): boolean {
  const normalized = normalizeRole(role);
  return USER_CABINET_ROLES.indexOf(normalized) !== -1;
}

export function getEntryUrlByRole(role?: string | null): string {
  const normalized = normalizeRole(role);
  const compact = normalized.replace(/_/g, '');

  if (normalized === 'admin') {
    return EntryUrlEnum.admin;
  }

  if (normalized === 'operator') {
    return EntryUrlEnum.operator;
  }

  if (compact === 'technicaloperator' || compact === 'technicalsupport') {
    return EntryUrlEnum.technical_operator;
  }

  return EntryUrlEnum.user;
}

export function getHomeUrlByRole(role?: string | null): string {
  const entryUrl = getEntryUrlByRole(role);

  if (entryUrl === EntryUrlEnum.user) {
    return '/cabinet/new';
  }

  if (entryUrl === EntryUrlEnum.operator) {
    return '/operator/new-deals';
  }

  return entryUrl;
}
